<template>
    <ChartFilter
        title="chartFilterMovements"
        @on-clean-filter="onCleanFilter"
        @on-filter="onFilter"
        :fieldsName="fieldsName"
        :filterType="filterType"
        v-slot="{ fields }"
    >
        <b-checkbox
            v-model="fields.movementTypes"
            class="mr-5"
            native-value="A"
        >
            Abonos
        </b-checkbox>
        <b-checkbox v-model="fields.movementTypes" native-value="C"
            >Cargos
        </b-checkbox>
        <b-taginput
            ref="tagsMovements"
            v-model="tags"
            icon="tag"
            placeholder="Bancos"
            class="mb-3 mt-3"
            autocomplete
            :open-on-focus="false"
            :ellipsis="true"
            :data="filteredTags"
            field="name"
            @typing="getFilteredTags"
            @blur="validateTags"
        >
            <template #selected="props">
                <b-tag
                    v-for="(tag, index) in props.tags"
                    :key="index"
                    :role="index"
                    :type="getType(tag)"
                    rounded
                    :tabstop="false"
                    ellipsis
                    closable
                    @close="removeTag(index, $event)"
                >
                    {{ tag.name }}
                </b-tag>
            </template>
        </b-taginput>
        <b-input
            v-model="fields.description"
            placeholder="Descripción"
            class="mb-3"
        ></b-input>
    </ChartFilter>
</template>

<script>
import ChartFilter from "@/components/chartFilter/ChartFilter";
export default {
    name: "FilterBankMovements",

    data() {
        return {
            fieldsName: [
                { name: "banks", default: [] },
                { name: "movementTypes", default: ["C", "A"] },
                { name: "description", default: "" },
            ],
            tags: [],
            filteredTags: this.autocompleteData,
        };
    },
    props: {
        autocompleteData: {
            type: Array,
            default: () => [],
        },
        filterType: {
            type: String,
            default: "Para el gráfico y movimientos bancarios",
        },
    },
    components: { ChartFilter },
    methods: {
        onFilter(emittedData) {
            const data = {
                ...emittedData,
                banks: this.tags
                    .filter((tag) => tag.id !== "")
                    .map((tag) => tag.id),
            };
            this.$emit("on-filter", data);
        },
        onCleanFilter() {
            this.tags = [];
            this.$emit("on-clean-filter");
        },
        getFilteredTags(text) {
            this.filteredTags = this.autocompleteData.filter((option) => {
                return (
                    option.name
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0
                );
            });
        },
        getType(tag) {
            if (!tag?.id) {
                return "is-danger";
            } else {
                return "is-light";
            }
        },
        validateTags(e) {
            if (e.target.value.length !== 0) {
                if (this.filteredTags.length === 0) {
                    if (
                        this.tags.filter((tag) => tag.name === e.target.value)
                            .length === 0
                    ) {
                        const tag = {
                            name: e.target.value,
                            id: "",
                        };
                        this.tags.push(tag);
                    }
                }
            }
        },
        removeTag(index) {
            this.tags.splice(index, 1);
        },
    },
};
</script>
